export function AccessGatewayIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 4.5H6.75A1.25 1.25 0 0 0 5.5 5.75v12.5A1.25 1.25 0 0 0 6.75 19.5h6.75"
        stroke="#FF4D8D"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10.5 12h8m0 0-2.75-2.75M18.5 12l-2.75 2.75"
        stroke="#FFFFFF"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
